import { render, staticRenderFns } from "./textEllipsis.vue?vue&type=template&id=7a1dc0d1&scoped=true"
import script from "./textEllipsis.vue?vue&type=script&lang=js"
export * from "./textEllipsis.vue?vue&type=script&lang=js"
import style0 from "./textEllipsis.vue?vue&type=style&index=0&id=7a1dc0d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1dc0d1",
  null
  
)

export default component.exports